var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.12,
    cx: 12.2776,
    cy: 12.2769,
    r: 10.2308,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2774 2.81348C7.05085 2.81348 2.81391 7.05042 2.81391 12.2769C2.81391 17.5035 7.05085 21.7404 12.2774 21.7404C17.5039 21.7404 21.7408 17.5035 21.7408 12.2769C21.7408 7.05042 17.5039 2.81348 12.2774 2.81348ZM1.2793 12.2769C1.2793 6.20288 6.2033 1.27887 12.2774 1.27887C18.3514 1.27887 23.2754 6.20288 23.2754 12.2769C23.2754 18.351 18.3514 23.275 12.2774 23.275C6.2033 23.275 1.2793 18.351 1.2793 12.2769ZM12.2774 10.4866C12.7011 10.4866 13.0447 10.8301 13.0447 11.2539V16.3693C13.0447 16.793 12.7011 17.1366 12.2774 17.1366C11.8536 17.1366 11.5101 16.793 11.5101 16.3693V11.2539C11.5101 10.8301 11.8536 10.4866 12.2774 10.4866ZM12.2774 9.20772C12.8424 9.20772 13.3005 8.74967 13.3005 8.18464C13.3005 7.61961 12.8424 7.16156 12.2774 7.16156C11.7123 7.16156 11.2543 7.61961 11.2543 8.18464C11.2543 8.74967 11.7123 9.20772 12.2774 9.20772Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default "/Frontend/static/media/info.d5cfaa30f06b22b6541b0a56cb6dcba4.svg";
export { ForwardRef as ReactComponent };